export default "dist/images/components-design-separator-control-wave-2.bc3ff78.png";